var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"icons"}},_vm._l((_vm.SVG),function(Icon){return _c('div',{attrs:{"hidden":""}},[_c('div',{staticStyle:{"font-size":"24px"},attrs:{"id":Icon.name},domProps:{"innerHTML":_vm._s(Icon.data)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }